// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__4zvzo"};